// extracted by css-extract-rspack-plugin
export default {"StackEntries":"StackEntryPreviewList-module__StackEntries__ogEtQ"};